import { TablePagination, TablePaginationProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC } from 'react';

import { FullTablePaginationActions } from './TablePaginationActions';

interface IFullPagination
  extends Pick<
    TablePaginationProps,
    'labelRowsPerPage' | 'count' | 'rowsPerPage' | 'page' | 'rowsPerPageOptions'
  > {
  setPage: (newPage: number) => void;
  setRowsPerPage: (val: number) => void;
  rowsPerPageOptions?: number[];
}

export const FullPagination: FC<IFullPagination> = ({
  labelRowsPerPage,
  rowsPerPageOptions,
  count,
  rowsPerPage,
  page,
  setPage,
  setRowsPerPage,
}) => {
  const classes = paginationStyles();
  return (
    <TablePagination
      labelRowsPerPage={labelRowsPerPage}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions ?? [10, 25, 50]}
      component="div"
      classes={{
        root: classes.paginationRoot,
      }}
      onPageChange={(e: unknown, newPage: number) => setPage(newPage)}
      onRowsPerPageChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setRowsPerPage(parseInt(e.target.value, 10));
      }}
      ActionsComponent={FullTablePaginationActions}
      SelectProps={{
        MenuProps: {
          disableScrollLock: true,
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                paddingRight: '16px !important',
              },
            },
          },
        },
        sx: {
          '@media (max-width: 899px)': {
            marginLeft: '0 !important',
            marginRight: '0 !important',
          },
        },
      }}
    />
  );
};

const paginationStyles = makeStyles((theme: Theme) => ({
  paginationRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    overflow: 'visible',
    minWidth: 0,
    flexWrap: 'wrap',

    '&& .MuiTablePagination-selectRoot': {
      marginLeft: 0,
      marginRight: 0,
    },
    '&& .MuiToolbar-gutters': {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
    '&& .MuiTablePagination-actions': {
      marginLeft: '2px',
      marginRight: '2px',
    },
    '&& .MuiTablePagination-displayedRows': {
      fontSize: '0.875rem',
      margin: '0 2px',
    },
    '&& .MuiTablePagination-selectLabel': {
      fontSize: '0.875rem',
      margin: '0',
      marginRight: '2px',
    },
    '&& .MuiTablePagination-select': {
      paddingLeft: '4px',
      paddingRight: '20px',
    },

    '@media only screen and (min-width: 900px)': {
      overflow: 'hidden',
      flexWrap: 'nowrap',

      '&& .MuiTablePagination-selectRoot': {
        marginLeft: '8px',
        marginRight: '32px',
      },
      '&& .MuiToolbar-gutters': {
        paddingLeft: 0,
        paddingRight: 0,
      },
      '&& .MuiTablePagination-actions': {
        marginLeft: '20px',
        marginRight: 0,
      },
      '&& .MuiTablePagination-displayedRows': {
        margin: 0,
      },
      '&& .MuiTablePagination-selectLabel': {
        margin: 0,
      },
      '&& .MuiTablePagination-select': {
        paddingLeft: '8px',
        paddingRight: '32px',
      },
    },
  },
}));
